// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3lcPj","selects":"Documents_selects__2O4Si"};